import { useAuthorizedQuery } from "../api/authorized-query";
import { seedgreenAPI } from "../api/axios";
import { NurseryDTO } from "../dtos/NurseryDTO";
import { STALE_TIME_LONG } from "../queries/query.constants";
import { useQuery } from "@tanstack/vue-query";
import _ from "lodash";
import { computed } from "vue";
const NURSERIES_STALE_TIME = STALE_TIME_LONG;
// Nurseries for the current customer
export function useNurseries() {
    const query = useQuery({
        enabled: useAuthorizedQuery(),
        queryKey: ["nurseries"],
        queryFn: async () => (await seedgreenAPI.get("v2/Nursery")).data,
        staleTime: NURSERIES_STALE_TIME,
        select: (data) => data?.map((nursery) => new NurseryDTO(nursery)) ?? [],
    });
    return {
        nurseries: query.data,
        nurseriesById: computed(() => _.keyBy(query.data.value, "id")),
        ...query,
    };
}
